import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=2f0e6ed1&scoped=true&"
import script from "./InfoDetails.vue?vue&type=script&lang=js&"
export * from "./InfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=2f0e6ed1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0e6ed1",
  null
  
)

export default component.exports